import { render, staticRenderFns } from "./TextAreaButton.vue?vue&type=template&id=e2ebf6dc&scoped=true&"
import script from "./TextAreaButton.vue?vue&type=script&lang=ts&"
export * from "./TextAreaButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ebf6dc",
  null
  
)

export default component.exports